module.exports = __webpack_public_path__ + "img/MN.749e0aa7.svg";